import React, { Component, Fragment } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import queryString from "query-string-for-all";
import { Frame } from "@conserveit/blocks";
import { sortActionData } from "../../utils/sorting";
import { PageHeader } from "../Layout/Page";

import InfoText from "./components/InfoText";
import ActionBar, { SEARCH_KEY } from "./components/ActionBar";
import ListView from "./components/ListView";
import { countOldIssues } from "./utils";

const StyledFrame = styled(Frame)`
  overflow: hidden;
`;

export default class Issues extends Component {
  static propTypes = {
    sortFilter: PropTypes.string.isRequired,
    sortDirection: PropTypes.string.isRequired,
    loading: PropTypes.bool,
    showClosed: PropTypes.bool,
    status: PropTypes.string,
    hideEdits: PropTypes.bool,
    handleClosedActionsTimeFrameChange: PropTypes.func.isRequired,
    closedOnStartDate: PropTypes.number,
  };

  static defaultProps = {
    showClosed: false,
    loading: true,
    status: undefined,
    closedOnStartDate: undefined,
  };

  constructor(props) {
    super(props);
    const query = queryString.parse(props.history.location.search)[SEARCH_KEY];
    this.state = {
      noResults: false,
      filteredData: [],
      sidebarOpen: false,
      oldCount: undefined,
      query,
    };
  }

  componentDidMount() {
    const { data } = this.props;
    if (!data) return;

    this.applySort(this.props.data);

    if (this.props.activeActionId) {
      this.setShowSidebar(false);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // If the data has changed, apply ordering
    if (prevProps.data !== this.props.data) {
      // If fitlered, use filtered, otherwise use props data.
      const data =
        this.state.filteredData.length > 0
          ? this.state.filteredData
          : this.props.data;

      this.applySort(data);
      this.updateOldCount(this.props.data);
    }
    if (prevState.filteredData !== this.state.filteredData) {
      this.updateOldCount(this.state.filteredData);
    }
    // If the sorting has changed, update ordering using currently
    // filtered state
    if (
      prevProps.sortFilter !== this.props.sortFilter ||
      prevProps.sortDirection !== this.props.sortDirection
    ) {
      this.applySort(this.state.filteredData);
    }

    if (this.props.activeActionId && prevState.sidebarOpen !== true) {
      this.setShowSidebar(true);
    }

    if (prevState.sidebarOpen && !this.props.activeActionId) {
      this.setShowSidebar(false);
    }

    if (prevProps.data !== this.props.data) {
      this.setNoResults(this.props.data);
    }
  }

  setShowSidebar = (isOpen) => {
    this.setState({ sidebarOpen: isOpen });
  };
  setNoResults = (data) => {
    if (data.length === 0) {
      this.setState({ noResults: true });
    }
  };
  updateOldCount = (data) => {
    this.setState({
      oldCount: countOldIssues(data),
    });
  };
  handleShowSidebar = () => this.setShowSidebar(true);

  handleHideSidebar = () => {
    this.props.onHideActionDetails();
    this.setShowSidebar(false);
  };

  applySort = (data) => {
    const { sortFilter, sortDirection } = this.props;
    this.setState({
      filteredData: sortActionData(data, sortFilter, sortDirection),
    });
  };

  handleSelectSite = ({ value }) => {
    this.props.onSelectSite(value);
  };

  handleRowClick = (id) => () => {
    const { history, loading } = this.props;

    // HOTFIX: If an action is still loading, don't attempt to request another one
    // TODO: Handle potential state mismatch properly
    if (loading) return;

    const qs = queryString.parse(history.location.search);
    const stringified = queryString.stringify({ ...qs, action: id });
    history.push({
      search: stringified,
    });
  };

  handleSearchStringChange = ({ filtered, query }) => {
    // Segment tracking - Searched actions
    // searchedEvent('actions', searchString)
    const { history, updateHistory } = this.props;
    const qs = queryString.parse(history.location.search);
    const searchString = query.length > 1 ? query : undefined;
    const stringified = queryString.stringify({
      ...qs,
      [SEARCH_KEY]: searchString,
    });

    history.replace({
      search: stringified,
    });
    updateHistory(history);

    if (filtered.length === 0) {
      this.setState({
        noResults: true,
        query,
      });
      return;
    }

    const { sortFilter, sortDirection } = this.props;
    const sorted = sortActionData(filtered, sortFilter, sortDirection);
    this.setState({
      noResults: false,
      filteredData: sorted,
    });
  };

  render() {
    const { filteredData, noResults, oldCount } = this.state;
    const {
      showClosed,
      handleClosedActionsTimeFrameChange,
      status,
      closedOnStartDate,
    } = this.props;

    return (
      <Fragment>
        <PageHeader>
          {oldCount !== undefined && (
            <InfoText
              showClosed={showClosed}
              active={filteredData.length}
              old={oldCount}
              closedOnStartDate={closedOnStartDate}
            />
          )}
        </PageHeader>

        <ActionBar
          history={this.props.history}
          initialSearch={this.state.query}
          data={this.props.data}
          hideEdits={this.props.hideEdits}
          noResults={noResults}
          onSearchStringChange={this.handleSearchStringChange}
          handleClosedActionsTimeFrameChange={
            handleClosedActionsTimeFrameChange
          }
          status={status}
        />
        <StyledFrame>
          <ListView
            sidebarOpen={this.state.sidebarOpen}
            onHideSidebar={this.handleHideSidebar}
            onShowSidebar={this.handleShowSidebar}
            onRowClick={this.handleRowClick}
            actionId={this.props.activeActionId}
            rows={filteredData}
            noResults={noResults}
          />
        </StyledFrame>
      </Fragment>
    );
  }
}
